<template>
  <!-- <div class="index-content">
    <div class="scrollbar"> -->
  <div class="aboutBox">
    <div class="tabBox">
      <div
        :class="index == tabNum ? 'selectSty' : ''"
        @click="tabClick(index)"
        v-for="(item, index) in tabList"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="contentBox" v-if="tabNum == 0">
      <div class="contentLeft">
        <p>广州松冬体育信息咨询有限公司成立于2011年，专注于体育行业的信息化、智慧化和体育咨询服务等领域，运用现代信息技术为体育赋能，并凭借丰富的体育行业经验，推动管理与服务的跨越式升级，助力国家体育事业的高质量发展。</p>
        <p>2020年，与中国联合网络通信集团有限公司全资子公司——中讯邮电咨询设计院有限公司，联合成立中讯邮电咨询设计院有限公司智慧体育研究院，让科技在多层次、全方位、宽领域为体育赋能</p>
      </div>
      <div class="contentRight">
        <img src="../../assets/image/image.jpeg" alt="" />
      </div>
    </div>
    <div class="fiveBox" v-if="tabNum == 1">
      <div class="sportBox">
        <div>
          <img src="../../assets/sport_into.png" style="object-fit: scale-down;" alt="">
          <div class="sportTitle">体育信息</div>
          <p style="line-height: 36px;font-size: 20px;">为竞技体育、全民健身、体育产业及大型赛会，提供系统设计、产品研发、平台运营、技术支撑等。</p>
        </div>

        <div>
          <img src="../../assets/sport_service.png" alt="" style="object-fit: scale-down;">
           <div class="sportTitle">体育咨询服务</div>
           <p  style="line-height: 36px;font-size: 20px;">为竞技体育、全民健身、体育产业及大型赛会，提供专业、卓越的统筹规划、咨询服务等。</p>
        </div>
      </div>
      <!-- <vue2-org-tree class="pcTree" name="test" :data="treeData" />
      <vue2-org-tree
        class="phoneTree"
        :horizontal="true"
        name="test"
        :data="treeData"
      /> -->
    </div>
    <div class="twoBox" id="pcTwoBox" v-if="tabNum == 2">
      <div class="topBox">
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            2011 年，广州松冬体育信息咨询有限公司正式成立，以专业姿态锚定体育行业赛道。怀揣对产业发展的前瞻洞察，公司以规范化运营开启稳步发展征程，为后续业务布局奠定坚实根基。
          </div>
          <div class="topAfter">
            <div class="topAfterText">启程立基</div>
            <div class="topAfterYear">2011年</div>
          </div>
        </div>
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
           2020 年，公司启动战略升级。整合行业资源与业务优势，明确信息化“平台”发展方向，研发「松冬智慧体育服务平台」。通过数字化技术重构服务链路，实现体育信息化从单体服务向微服务的转型跨越。
          </div>
          <div class="topAfter">
            <div class="topAfterText">整合突破</div>
            <div class="topAfterYear">202年</div>
          </div>
        </div>
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            面向未来，公司以“专业筑底、敬业立本、宏业致远”为初心，持续开拓市场版图。秉持技术创新与服务深耕双轮驱动战略，致力于成为体育行业数字化转型的标杆企业，为客户提供更具价值的专业服务与可靠保障。
          </div>
          <div class="topAfter">
            <div class="topAfterText">拓界前行</div>
            <div class="topAfterYear">未来</div>
          </div>
        </div>
      </div>
      <div class="topBox">
        <div class="topOne topTwo">
          <div class="topOneText">
           2015 年，公司立足体育产业生态，深度探索行业发展趋势。遵循“以规律为纲、以实践为基” 的发展理念，持续扎根体育服务领域，在体育信息化、体育咨询发展等多元场景中沉淀专业经验，逐步构建差异化竞争优势。
          </div>
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topAfter">
            <div class="topAfterText">探索深耕</div>
            <div class="topAfterYear">2015年</div>
          </div>
        </div>
        <div class="topOne topTwo">
          <div class="topOneText">
            2025 年，平台完成架构与服务模式的双重迭代：以用户需求为核心，优化技术底层逻辑，深化“专业服务+个性定制”的服务模式，为客户提供更具精准度与场景适配性的智慧体育服务解决方案。
          </div>
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topAfter">
            <div class="topAfterText">升级焕新</div>
            <div class="topAfterYear">2025年</div>
          </div>
        </div>
      </div>
    </div>
    <div class="twoBox" id="phoneTwoBox" v-if="tabNum == 2">
      <div class="topBox">
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            2011 年，广州松冬体育信息咨询有限公司正式成立，以专业姿态锚定体育行业赛道。怀揣对产业发展的前瞻洞察，公司以规范化运营开启稳步发展征程，为后续业务布局奠定坚实根基。
          </div>
          <div class="topAfter">
            <div class="topAfterText">启程立基</div>
            <div class="topAfterYear">2011年</div>
          </div>
        </div>
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            2015 年，公司立足体育产业生态，深度探索行业发展趋势。遵循“以规律为纲、以实践为基” 的发展理念，持续扎根体育服务领域，在体育信息化、体育咨询发展等多元场景中沉淀专业经验，逐步构建差异化竞争优势。
          </div>
          <div class="topAfter">
            <div class="topAfterText">探索深耕</div>
            <div class="topAfterYear">2015年</div>
          </div>
        </div>
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            2020 年，公司启动战略升级。整合行业资源与业务优势，明确信息化“平台”发展方向，研发「松冬智慧体育服务平台」。通过数字化技术重构服务链路，实现体育信息化从单体服务向微服务的转型跨越。
          </div>
          <div class="topAfter">
            <div class="topAfterText">整合突破</div>
            <div class="topAfterYear">2020年</div>
          </div>
        </div>
          <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
           2025 年，平台完成架构与服务模式的双重迭代：以用户需求为核心，优化技术底层逻辑，深化“专业服务+个性定制”的服务模式，为客户提供更具精准度与场景适配性的智慧体育服务解决方案。
          </div>
          <div class="topAfter">
            <div class="topAfterText">升级焕新</div>
            <div class="topAfterYear">2025年</div>
          </div>
        </div>
        <div class="topOne">
          <!-- <img src="../../assets/image/zhty.png" alt="" /> -->
          <div class="topOneText">
            面向未来，公司以“专业筑底、敬业立本、宏业致远”为初心，持续开拓市场版图。秉持技术创新与服务深耕双轮驱动战略，致力于成为体育行业数字化转型的标杆企业，为客户提供更具价值的专业服务与可靠保障。
          </div>
          <div class="topAfter">
            <div class="topAfterText">拓界前行</div>
            <div class="topAfterYear">未来</div>
          </div>
        </div>
        
      </div>
    </div>
 
    <div class="threeBox" v-if="tabNum == 3">
      <div>
        <span>战略思想：</span
        >坚持厚积薄发的可持续发展战略思想，不断积累和丰富实战经验，壮大自身，服务客户。
      </div>
      <div>
        <span>服务精神：</span
        >始于热爱、止于至善，保持专业、敬业、宏业的核心价值观念，为客户提供高质服务。
      </div>
      <div>
        <span>服务定位：</span
        >专注于体育行业信息化和信息咨询服务，打造面向客户统一运营和面向产品专业运营的业务和运营支撑体系。
      </div>
      <div>
        <span>发展愿景：</span
        >依托现有业务经验，以广东省体育局为辐射点，向全国范围进行客户延伸。
      </div>
    </div>
    <div class="fourBox" v-if="tabNum == 4">
      <div>
        &nbsp;&nbsp;&nbsp;&nbsp;经过10年余的发展与沉淀，培养和积累了一批基础功底扎实、实战经验丰富、专业分工合理的体育行业服务人才队伍，团队核心人员具备北京奥运会、广州亚运会、深圳大运会、全国农民运动会、全国运动会、广东省运动会、杭州亚运会、汕头亚青会等大型赛事和广州市市运会、东莞市市运会及相关单项赛事的服务工作经历，有着丰富的体育赛事管理、计算机信息系统建设与服务的经验。
      </div>
      <div class="fourList">
        <div>
          <span>体育发展团队：</span
          >提供体育产业、体育项目相关的统筹规划和咨询服务，为大型综合性体育赛事提供专业化的技术支撑和咨询服务。
        </div>
        <div>
          <span>软件研发团队：</span
          >负责公司自有产品和客户定制化软件的框架构思设计、基础技术研究及业务功能实现和升级。
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
  </div> -->
</template>

<script>
export default {
  name: "about-index",
  components: {},
  data() {
    return {
      tabList: ["公司简介", "核心业务","发展历程", "企业文化", "团队介绍"],
      tabNum: 0,
      treeData: {
        label: "总经理",
        children: [
          {
            label: "行政部",
            children: [{ label: "部门经理" }, { label: "人事经理" }],
          },
          {
            label: "财务部",
            children: [
              { label: "部门经理" },
              { label: "财务" },
              { label: "出纳" },
            ],
          },
          {
            label: "软件开发部",
            children: [
              { label: "技术总监" },
              { label: "项目经理" },
              { label: "产品经理" },
              { label: "开发工程师" },
              { label: "UI设计师" },
              { label: "测试工程师" },
              { label: "实施工程师" },
            ],
          },
          {
            label: "体育发展部",
            children: [
              { label: "部门经理" },
              { label: "项目经理" },
              { label: "体育专员" },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    tabClick(num) {
      this.tabNum = num;
    },
    init() {
      const self = this;
      let sign = self.sign;
      self.$store.commit("showLoading");

      getHome({ sign }).then((res) => {
        if (res.code == 200) {
          self.$store.commit("hideLoading");
        } else {
          self.$toast(res.msg);
        }
      });
    },
    onSearch() {},
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/org-tree.scss";
</style>
<style lang="scss" scoped>
.sportBox{

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .sportTitle{
    width: 260px;
    padding: 10px 0;
    border: #ed6f2c solid 1px;
    border-radius: 10px 10px 10px 10px;
    background: #ed6f2c;
    color: #ffffff;
    font-size: 22px;
    font-weight: 800;
    text-align: center;
    justify-self: center;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
    transform: translateY(-25px);
   
  }
  p{
     margin-top: -16px;
  }
}
.aboutBox {
  width: 1200px;
  margin: 0 auto;
  min-height: 80%;
}
.tabBox {
  width: 100%;
  margin-top: 40px;
  div {
    display: inline-block;
    margin-right: 80px;
    cursor: pointer;
  }
  .selectSty {
    position: relative;
    color: #1e50ae;
    font-weight: bold;
    &::after {
      position: absolute;
      content: "";
      width: 46px;
      height: 2px;
      background-color: #1e50ae;
      bottom: -6px;
      left: 5%;
      border-radius: 4px;
    }
  }
}
.fiveBox {
  padding: 40px 0;
}
.twoBox {
  width: 100%;
  padding: 80px 0;
  display: flex;
  .topBox {
    flex: 1;
    &:first-child {
      border-right: 1px dashed #1e50ae;
    }
    .topOne.topTwo {
      margin-top: 200px;
      margin-bottom: 0;
      &::after {
        left: -6px;
      }
      .topAfter {
        left: -95px;
        right: auto;
        text-align: right;
      }
    }
    .topOne {
      position: relative;
      text-align: right;
      padding: 38px;
      margin-bottom: 200px;
      &::after {
        position: absolute;
        content: "";
        width: 12px;
        height: 12px;
        background-color: #1e50ae;
        border-radius: 50%;
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
      }
      .topAfter {
        position: absolute;
        right: -95px;
        top: 50%;
        transform: translateY(-50%);
        text-align: left;
        .topAfterText {
          font-size: 18px;
          color: #1e50ae;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .topAfterYear {
        }
      }
      img {
        width: 240px;
        height: 160px;
        border: 10px solid #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(176, 209, 215, 0.3);
      }
      .topOneText {
        width: 240px;
        padding: 28px 16px 0;
        box-sizing: border-box;
        display: inline-block;
        text-align: left;
        line-height: 28px;
      }
    }
  }
}
.fourBox {
  padding: 40px 0;
  line-height: 34px;
  .fourList {
    padding: 10px 0;
    div {
      padding-left: 20px;
      span {
        position: relative;
        font-weight: bold;
        &::after {
          position: absolute;
          content: "";
          width: 6px;
          height: 6px;
          background-color: #1e50ae;
          left: -18px;
          top: 40%;
          transform: rotate(45deg);
        }
      }
    }
  }
}
.threeBox {
  padding: 40px 0;
  line-height: 34px;
  div {
    padding-left: 20px;
    span {
      position: relative;
      font-weight: bold;
      &::after {
        position: absolute;
        content: "";
        width: 6px;
        height: 6px;
        background-color: #1e50ae;
        left: -18px;
        top: 40%;
        transform: rotate(45deg);
      }
    }
  }
}
.contentBox {
  width: 100%;
  padding: 40px 0;
  box-sizing: border-box;
  display: flex;
  .contentLeft {
    flex: 1;
    padding: 10px 100px 0 0;
    box-sizing: border-box;
    line-height: 34px;
    span {
      font-weight: bold;
    }
    p{
      margin-bottom: 15px;
      text-indent: 30px;
    }
  }
  .contentRight {
    width: 400px;
    img {
      width: 100%;
    }
  }
}
@media only screen and (min-width: 768px) {
 .sportBox{
  flex-direction: row;
  div{
    flex: 1;
    margin-right: 60px;
    &:last-child{
      margin-right: 0;
    }
  }
}
  .fiveBox {
    .phoneTree {
      display: none;
    }
    .pcTree {
      display: block;
    }
  }
  #phoneTwoBox {
    display: none;
  }
  #pcTwoBox {
    display: flex;
  }
}
@media only screen and (max-width: 768px) {
  .sportBox{
  flex-direction: column;
 
  div{
    flex: 1;
    margin-right: 0;
  }
}
  #phoneTwoBox {
    display: block;
  }
  #pcTwoBox {
    display: none;
  }
  .twoBox {
    padding: 40px 0;
    .topBox {
      width: 82%;
      .topOne {
        padding: 0;
        text-align: left;
        margin-bottom: 30px;
        .topOneText {
          padding: 10px 16px 0;
        }
        .topAfter {
          right: -80px;
        }
      }
    }
  }
  .fiveBox {
    .phoneTree {
      display: block;
      padding: 0;
    }
    .pcTree {
      display: none;
    }
  }
  .aboutBox {
    width: 92%;
    .tabBox {
      height: 30px;
      line-height: 30px;
      margin-top: 26px;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      div {
        margin-right: 26px;
      }
      .selectSty {
        &::after {
          bottom: 0;
        }
      }
    }
    .contentBox {
      padding: 20px 0;
      display: block;
      .contentLeft {
        padding: 10px 0;
       
      }
      .contentRight {
        width: 100%;
      }
    }
  }
}
</style>
